import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { hydrateAuth } from './store/auth/auth.actions';

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>',
  standalone: false
})
export class AppComponent implements OnInit {
  constructor(private store: Store) {}

  ngOnInit(): void {
    // Restore authentication state from localStorage on app initialization
    this.store.dispatch(hydrateAuth());
  }
}
